export default __webpack_public_path__ + "static/Umair-87ef33811a3fadba09c11d0c33e59cce.jpg";